module.exports = __webpack_public_path__ + "assets/CMidpoint.2e87214c2546777844ed8e31216f2f60.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CMidpoint.gmt
// module id = 908
// module chunks = 0